import taskItemTemplate from './taskItem.html';

const taskItem = {
    bindings: {
        callingPageRefId: '@',
        callingPage: '@',
        task: '=',
        deleteTask: '&',
        tasksCount: '@?',
    },
    template: taskItemTemplate,
    controller: function ($state) {
        this.displayFullName = (task) => {
            let name = '';
            let temp = this.displayName(task);
            if (task.campaign && task.campaign.campaignTitle.length > 0)
                name = name + task.campaign.campaignTitle + ' | ';
            if (temp && temp.length > 0) name = name + temp + ' | ';
            if (task.investor && task.investor.investorName.length > 0)
                name = name + task.investor.investorName + ' | ';
            if (name.length > 0) return name.substring(0, name.length - 3);
            else return '';
        };

        this.displayName = (task) => {
            if (
                !task.contactExtension ||
                !task.contactExtension.contactInfo ||
                !task.contactExtension.contactInfo.contact
            )
                return '';
            let name = '';
            if (
                task.contactExtension.contactInfo.contact.salutation &&
                task.contactExtension.contactInfo.contact.salutation.length > 0
            )
                name =
                    name +
                    task.contactExtension.contactInfo.contact.salutation +
                    ' ';
            if (
                task.contactExtension.contactInfo.contact.firstName &&
                task.contactExtension.contactInfo.contact.firstName.length > 0
            )
                name =
                    name +
                    task.contactExtension.contactInfo.contact.firstName +
                    ' ';
            if (
                task.contactExtension.contactInfo.contact.lastName &&
                task.contactExtension.contactInfo.contact.lastName.length > 0
            )
                name =
                    name +
                    task.contactExtension.contactInfo.contact.lastName +
                    ' ';
            if (name.length > 0) return name.substring(0, name.length - 1);
            else return '';
        };

        this.getTaskUrl = () => {
            return $state.href('taskDetail', {
                taskId: this.task.task.taskId,
                callingPage: this.callingPage,
                referenceId: this.callingPageRefId,
                tasksCount: this.tasksCount,
            });
        };
    },
};

export default taskItem;



/** WEBPACK FOOTER **
 ** ./src/app/directives/taskList/taskItem.js
 **/